var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{attrs:{"id":"loader"}},[_c('div',{staticClass:"loading-info"},[_c('img',{attrs:{"src":require("@/assets/img/logo-with-bees.svg")}}),_c('div',{staticClass:"load-text"},[_vm._v("Preparing Number™...")])])])])
}]

export { render, staticRenderFns }